import ProductMediaSlider from "./product-media-slider";

export default ProductMediaSlider;